import React, { useRef, useState } from "react";
import EventIcon from "@mui/icons-material/Event";
import {
  Box,
  Button,
  Divider,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import { useEffect } from "react";
import dayjs from "dayjs";
import {
  getItemCategoryWiseCounterSaleReportXlsx,
  getMonthlyDetails,
} from "./reportsApi";
import {
  getEndOfMonth,
  getStartOfMonth,
  payloadDateFormat,
} from "../../../utils/commonUtils";

import DownloadIcon from "@mui/icons-material/Download";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import SalesSummary from "../../../common/salarySummery";
import {
  getFirstDateOfCurrentMonthPayloadFormate,
  getFirstDateOfMonth,
  getLastDateOfCurrentMonthPayloadFormat,
} from "../../../utils/commonUtils";
import { getCounterSalesReport } from "./reportsApi";
import TableReport from "./table";
import DateComponent from "./dateComponent";
import axios from "axios";
import { ArrowBackIcon } from "../../../common/icon";
import { useNavigate } from "react-router";

const data = [
  { category: "Hair Wash", items: 11, amount: "₹ 2443.38", percent: "56.09%" },
  {
    category: "Head Massage",
    items: 21,
    amount: "₹ 2443.38",
    percent: "77.00%",
  },
  { category: "Manicure", items: 1, amount: "₹ 2443.38", percent: "44.00%" },
  {
    category: "Basic Facial",
    items: 3,
    amount: "₹ 2443.38",
    percent: "33.00%",
  },
  { category: "Shaving", items: 4, amount: "₹ 2443.38", percent: "33.00%" },
  {
    category: "Detox Treatment",
    items: 5,
    amount: "₹ 2443.38",
    percent: "33.00%",
  },
  {
    category: "Eyelash Lifting",
    items: 23,
    amount: "₹ 2443.38",
    percent: "44.00%",
  },
];

export default function RawMaterialReportT({ data }) {
  const [open, setOpen] = useState(false);
  const datePickerRef2 = useRef();

  //------------date
  const [date, setDate] = useState(null);
  const [displayEndDate, setDisplayEndDate] = useState(null);
  const [dateFocused, setDateFocused] = useState(false);
 const navigate = useNavigate();

  const [SelectedStartDate, setSelectedStartDate] = useState(dayjs());
  const [SelectedEndDate, setSelectedEndDate] = useState(dayjs());
  
  
  const [startDateFormat, setstartDateFormat] = useState(
    dayjs().format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(dayjs().format("YYYY-MM-DD"));

  const datePickerOnChangeEnd = (date) => {
    const dateStr = date.toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    const dateStr2 = date.toLocaleDateString("en-GB", {
      year: "numeric",
      month: "long",
      day: "2-digit",
    });
    const [month, day, year] = dateStr.split("/");
    const formattedDate = `${year}-${day.padStart(2, "0")}-${month.padStart(
      2,
      "0"
    )}`;
    let dateContainer = String(dateStr2).split(" ");
    var year2 = dateContainer[2];
    var month2 = dateContainer[1];
    var day2 = dateContainer[0];
    var formattedDate2 = day2 + "-" + month2 + "-" + year2;
    console.log("format date ", formattedDate);
    datePickerRef2.current.setOpen(true);
    setSelectedEndDate(date);
    setDisplayEndDate(formattedDate2);
    setEndDate(formattedDate);
  };

  function addLeadingZero(value) {
    return value < 10 ? "0" + value : value;
  }

  const displayDateFormat = () => {
    var currentDate = new Date();
    let dateContainer = String(currentDate).split(" ");

    var year = dateContainer[2];
    var month = dateContainer[1];

    var day = dateContainer[3];

    var formattedDate =
      year + "-" + addLeadingZero(month) + "-" + addLeadingZero(day);

    return formattedDate;
  };
  const [rawMaterialReports, setRawMaterialReports] = useState({
    totalRawMaterialValue: null,
    rawMaterialDateDetails: [],
  });
  const [billFilter, setBillFilter] = useState("cash");

  const getYear = (date) => {
    let ar = date.split("-");
    return ar[ar.length - 1];
  };
  // const [date, setDate] = useState(getYear(displayDateFormat()));

  const [startDate, setStartDate] = useState(new Date());
  const [search, setSearch] = useState("");
  const datePickerRef = useRef();

  const openDatePicker = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };

  const getData = async (param) => {
    await getMonthlyDetails(param).then((res) => {
      console.log("Gst Report ", res?.data?.data);
      setRawMaterialReports({
        totalRawMaterialValue: res?.data?.data?.totalRawMaterialValue,
        rawMaterialDateDetails: res?.data?.data?.rawMaterialDateDetails,
      });
    });
  };

  const datePickerOnChange = (date) => {
    const dateStr = date.toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    const dateStr2 = date.toLocaleDateString("en-GB", {
      year: "numeric",
      month: "long",
      day: "2-digit",
    });
    const [month, day, year] = dateStr.split("/");
    const formattedDate = `${year}-${day.padStart(2, "0")}-${month.padStart(
      2,
      "0"
    )}`;
    let dateContainer = String(dateStr2).split(" ");
    var year2 = dateContainer[2];
    var month2 = dateContainer[1];
    var day2 = dateContainer[0];
    var formattedDate2 = day2 + "-" + month2 + "-" + year2;
    datePickerRef2.current.setOpen(true);

    setDate(formattedDate2);
    setstartDateFormat(formattedDate);
    setSelectedStartDate(date);
  };

  useEffect(() => {
    console.log("datE ", date);
    getData({
      // year: Number(payloadDateFormat().split("-")[0]),
      fromDate: startDateFormat,
      toDate: endDate,
    });
  }, [startDateFormat, endDate]);
  useEffect(() => {
    console.log("datE ", date);
    getData({
      // year: Number(payloadDateFormat().split("-")[0]),
      fromDate: startDateFormat,
      toDate: endDate,
    });
  }, []);

  const downloadXLSXFile = async (param) => {
    try {
      // const response = await axios.post(
      //   "user/api/v1/Reports/RawMaterialRPTXlsx",
      //   param,
      //   {
      //     responseType: "blob",
      //   }
      // );

      const response = await getItemCategoryWiseCounterSaleReportXlsx(param, {
        responseType: "blob",
      });

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "file.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading XLSX file:", error);
    }
  };

  //   const [SelectedEndDate, setSelectedEndDate] = useState(null);
  return (
    <Box
      sx={{
        py: "17px",
        px: { sm: "30px", xs: "20px" },
        background: "#ede9ff",
        minHeight: "100vh",
      }}
    >
      <Grid container spacing={2} alignItems="center">
        <Grid container alignItems="center" spacing={2}>
          {/* Back Icon */}
          <Grid item>
            <ArrowBackIcon
              sx={{ cursor: "pointer" }}
              onClick={() => navigate("/home")}
            />
          </Grid>

          {/* Title Section */}
          <Grid item xs>
            <Box
              sx={{
                background:
                  "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
                padding: "10px",
                mt: "10px",
                borderRadius: "5px",
                color: "#01008B", // optional text color
                textAlign: "left",
                marginBottom: "10px",
                fontFamily: "'Montserrat', sans-serif",
                fontSize: "20px",
                fontWeight: 500,
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontSize: { xs: "12px", sm: "13px", md: "18px" },
                }}
              >
                Raw Material Report
              </Typography>
            </Box>
          </Grid>
        </Grid>
        {/* Date Input */}
        <Grid
          item
          xs={12}
          sm={9}
          md={10}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <DateComponent
            date={date}
            setDate={setDate}
            displayEndDate={displayEndDate}
            setDisplayEndDate={setDisplayEndDate}
            dateFocused={dateFocused}
            setDateFocused={setDateFocused}
            SelectedStartDate={SelectedStartDate}
            setSelectedStartDate={setSelectedStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            SelectedEndDate={SelectedEndDate}
            setSelectedEndDate={setSelectedEndDate}
            startDateFormat={startDateFormat}
            setstartDateFormat={setstartDateFormat}
          />
        </Grid>

        {/* Download Button */}
        <Grid
          item
          md={2}
          sm={3}
          xs={12}
          sx={{
            padding: "0px",
          }}
        >
          <Button
            variant="contained"
            fullWidth
            onClick={() => {
              downloadXLSXFile({
                fromDate: startDateFormat,
                toDate: endDate,
              });
            }}
            sx={{
              height: "40px",
              backgroundColor: "#14008B",
              padding: "0px",
              fontSize: { xs: "12px", sm: "12px", md: "15px" },
            }}
            endIcon={<DownloadIcon />}
          >
            Download
          </Button>
        </Grid>
      </Grid>

      {/* Total Sale */}
      <Grid container alignItems="center" my={1}>
        <Grid
          item
          xs={"auto"}
          sx={{
            padding: "8px 16px",
            margin: "8px 8px 0px 0",
            fontWeight: "500",
            backgroundColor: "#CCCCFF",
            borderRadius: "8px",
          }}
        >
          <Typography
            component="p"
            sx={{
              display: "flex",
              alignItems: "center",
              marginLeft: "5px",
              color: "#00008B",
            }}
          >
            <Typography
              component="span"
              sx={{
                fontWeight: 500,
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              Total Raw Material Value:&nbsp;&nbsp;&nbsp;
            </Typography>
            <Typography
              component="span"
              sx={{
                fontWeight: "bold",
                marginLeft: "8px",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              {rawMaterialReports?.totalRawMaterialValue?.toFixed(2)}
            </Typography>
          </Typography>
        </Grid>
      </Grid>

      {/* Table */}
      <Box mt={2} sx={{ borderRadius: 2, background: "#fff" }}>
        <TableReport
          salesData={[]}
          colName={[
            {
              title: "Category",
              attribute: {
                xs: 3,
              },
            },
            {
              title: "Items",
              attribute: {
                xs: 3,
              },
            },
            {
              title: "Amount",
              attribute: {
                xs: 3,
              },
            },
            {
              title: "Category",
              attribute: {
                xs: 3,
              },
            },
          ]}
          data={rawMaterialReports?.rawMaterialDateDetails ?? []}
        />
      </Box>
    </Box>
  );
}
